namespace Solovis.Reports.ReportHelpers.AggregateExposureOverTime {

    export class AggregateExposureOverTimeReportGenerator {

        public static generateReportDefinition() {

            let dataSourceForExposure = {
                name: "exposure",
                path: "/Solovis/Exposure/AggregateExposureOverTime",

                parameterMap: function (parameters, more) {
                    let params: any = {};

                    let combinedSelectionSet = InvData.SelectionSetHelper.unionAssetListWithSelectionSet(parameters.assetList, parameters.assetSelectionSet);

                    params.componentSelectionSet = combinedSelectionSet;

                    params.exposureRef = {
                        exposureType: parameters.exposureType
                    };

                    if (parameters.profile) {
                        params.exposureRef.profileId = parameters.profile.id;
                    }

                    if (parameters.tagSet) {
                        params.exposureRef.tagSetId = parameters.tagSet.tagSetId;
                    }

                    if (parameters.asOfDayId) {
                        params.dayId = parameters.asOfDayId;
                    }
                    else {
                        params.dayId = InvData.DayId.today();
                    }

                    params.periodLength = parameters.periodLength;
                    params.periodsBack = parameters.periodsBack;

                    if (parameters.targetCurrency) {
                        params.targetCurrencyId = parameters.targetCurrency.id;
                    }

                    if (parameters.sourceData) {
                        params.useBookedValues = parameters.sourceData.useBookedValues;
                        params.knowledgeDateTimestamp = parameters.sourceData.knowledgeDateTimestamp;
                    }

                    params.includeTagSet = true;

                    return params;
                },

                postProcess: function (loadedDataSet, more) {
                    var lineItems = [];

                    var tagSet = new InvData.Models.TagSet(loadedDataSet.tagSet);

                    var modelEnv = new InvData.ModelEnvironment();
                    modelEnv.tagSets.add(tagSet);

                    var overallByDay = loadedDataSet.overallByDay;

                    var runIdToGroupMap = {};

                    var maxDepth = 0;
                    $(loadedDataSet.groups).each(function (i, group: any) {
                        maxDepth = Math.max(group.depth, maxDepth);
                    });

                    $(loadedDataSet.groups).each(function (i, group: any) {
                        runIdToGroupMap[group.runId] = group;

                        // Collect level labels.
                        var levelLabels = {};
                        var currentGroup = group;
                        while (currentGroup) {
                            levelLabels["levelLabel_" + currentGroup.depth] = currentGroup.label;
                            currentGroup = runIdToGroupMap[currentGroup.parentRunId];
                        }
                        for (let levelCo = group.depth + 1; levelCo <= maxDepth; levelCo++) {
                            levelLabels["levelLabel_" + levelCo] = group.label;
                        }

                        $(group.byDay).each(function (j, dayEntry: any) {
                            var lineItem: any = {
                                runId: group.runId,
                                parentRunId: group.parentRunId,
                                label: group.label,
                                fullLabelPath: group.fullLabelPath,
                                dayId: dayEntry.dayId,
                                isLeaf: group.isLeaf,
                                tagId: group.tagId,
                                depth: group.depth,
                                levelLabels: levelLabels
                            };

                            lineItem.fullGroupNodeId = group.runId + "-" + dayEntry.dayId;
                            if (Solovis.isNotNull(group.parentRunId)) {
                                lineItem.fullParentGroupNodeId = group.parentRunId + "-" + dayEntry.dayId;
                            }

                            lineItem.long = dayEntry.long;
                            lineItem.short = dayEntry.short;
                            lineItem.net = dayEntry.long + dayEntry.short;
                            lineItem.gross = dayEntry.long - dayEntry.short;

                            var overall = overallByDay[j];
                            if (overall.overallValue) {
                                lineItem.longPercentage = lineItem.long / overall.overallValue;
                                lineItem.shortPercentage = lineItem.short / overall.overallValue;
                                lineItem.netPercentage = lineItem.net / overall.overallValue;
                                lineItem.grossPercentage = lineItem.gross / overall.overallValue;
                            }

                            lineItems.push(lineItem);
                        });
                    });

                    var dataSet = {
                        lineItems: lineItems,
                        originalDataSet: loadedDataSet,
                        tagSet: tagSet,
                        modelEnv: modelEnv,
                        maxDepth: maxDepth
                    };

                    return dataSet;
                }
            };

            var report = {

                parameters: [
                    {
                        name: "assetList", label: "Assets", parameterType: "entityOrInvestment", list: true,
                        help: "All of the individual specified assets will be combined to create a composite for exposure analysis."
                    },

                    { name: "assetSelectionSet", label: "Asset Selection Set", parameterType: "assetSelectionSet" },

                    { name: "asOfDayId", label: "As Of", parameterType: "dateIndex" },

                    {
                        name: "periodLength",
                        label: "Period Length",
                        parameterType: "choice",
                        initialValue: "Month",
                        settings: {
                            options: [
                                { label: "Day", value: "Day" },
                                { label: "Month", value: "Month" },
                                { label: "Quarter", value: "Quarter" },
                                { label: "Year", value: "Year" },
                                { label: "Fiscal Year", value: "FiscalYear" }
                            ]
                        }
                    },

                    { name: "periodsBack", label: "Periods Back", parameterType: "integer" },

                    {
                        name: "profile", label: "Profile", parameterType: "exposureProfile",
                        validation: { required: true }
                    },
                    { name: "tagSet", label: "Tag Set", parameterType: "tagSet", settings: { dependsOn: { exposureProfile: "profile" } } },

                    {
                        name: "exposureType",
                        label: "Exposure Type",
                        parameterType: "choice",
                        initialValue: "MarketValue",
                        settings: {
                            options: [
                                { label: "Market Value", value: "MarketValue" },
                                { label: "Notional", value: "Notional" },
                                { label: "Delta-Adjusted Notional", value: "DeltaAdjustedNotional" },
                                { label: "Commitment Amount", value: "CommitmentAmount" }
                            ]
                        }
                    },

                    { name: "targetCurrency", label: "Target Currency", parameterType: "currency" },

                    {
                        name: "sourceData", label: "Source Data", parameterType: "sourceData",
                        settings: { hideStoredPerformance: true, hideAttributionBenchmarkSource: true, hideUseBlendedValues: true }
                    }
                ],

                root: {
                    elementName: "Root",

                    layout: "Vertical",

                    children: [
                        {
                            partControl: "Solovis.Reports.Parts.Tables.DataTableControl",
                            elementName: "AggregateExposureTable",

                            settings: {
                                columns: function () {
                                    var exposure = this.dataSets.exposure;

                                    var columns = [
                                        { id: "fullGroupNodeId", field: "fullGroupNodeId", label: "Group Id", dataType: "integer", hiddenByDefault: true },
                                        { id: "fullParentGroupNodeId", field: "fullParentGroupNodeId", label: "Parent Group Id", dataType: "integer", hiddenByDefault: true },

                                        { id: "label", field: "label", label: "Group", dataType: "string" },
                                        { id: "fullLabelPath", field: "fullLabelPath", label: "Full Label Path", dataType: "string", hiddenByDefault: true },
                                        { id: "dayId", field: "dayId", label: "Date", dataType: "dayId" },

                                        { id: "longPercentage", field: "longPercentage", label: "Long", superHeaders: ["%"], dataType: "percentage" },
                                        { id: "shortPercentage", field: "shortPercentage", label: "Short", superHeaders: ["%"], dataType: "percentage" },
                                        { id: "netPercentage", field: "netPercentage", label: "Net", superHeaders: ["%"], dataType: "percentage" },
                                        { id: "grossPercentage", field: "grossPercentage", label: "Gross", superHeaders: ["%"], dataType: "percentage" },

                                        { id: "long", field: "long", label: "Long", superHeaders: ["Amount"], dataType: "currency" },
                                        { id: "short", field: "short", label: "Short", superHeaders: ["Amount"], dataType: "currency" },
                                        { id: "net", field: "net", label: "Net", superHeaders: ["Amount"], dataType: "currency" },
                                        { id: "gross", field: "gross", label: "Gross", superHeaders: ["Amount"], dataType: "currency" },

                                        { id: "isLeaf", field: "isLeaf", label: "Is Leaf", dataType: "bool", hiddenByDefault: true },
                                        { id: "depth", field: "depth", label: "Depth", dataType: "integer", hiddenByDefault: true },
                                        {
                                            id: "tag", field: "tagId", label: "Tag", dataType: "tagId", hiddenByDefault: true,
                                            tagSetId: exposure.tagSet.id
                                        }
                                    ];

                                    for (var i = 0; i <= exposure.maxDepth; i++) {
                                        columns.push({
                                            id: ("levelLabel_" + i), field: ("levelLabels.levelLabel_" + i), label: "Level " + i, dataType: "string", hiddenByDefault: true
                                        });
                                    }

                                    return columns;
                                },

                                groupBy: ["all"],

                                groups: function () {
                                    var groups = [];

                                    groups.push({
                                        id: "all",
                                        label: "All",
                                        dataRowsForGroups: true,
                                        field: "fullParentGroupNodeId",
                                        groupValueField: "fullGroupNodeId",
                                        htmlFormatter: function (value, valueContext) {
                                            var span = $("<span>");
                                            var backingRow = valueContext.row._backingRow;
                                            if (backingRow) {
                                                var assetLabel = backingRow.label;
                                                if (!backingRow.fullParentGroupNodeId) {
                                                    var dateStr = InvData.DayId.format(backingRow.dayId);
                                                    span.text(assetLabel + " (" + dateStr + ")");
                                                }
                                                else {
                                                    span.text(assetLabel);
                                                }
                                            }

                                            return span;
                                        }
                                    });

                                    return groups;
                                },

                                cellContextMenuItems: function (cellContext) {                                    
                                    let row = cellContext.row;
                                    if (row._backingRow) {
                                        row = row._backingRow;
                                    }                                    

                                    let dayId = row.dayId;
                                    let parameters = cellContext.reportControl.getSerializedParameterValues();
                                    let exposure = cellContext.reportControl.getReportPartControl("AggregateExposureTable").dataSets.exposure;                                    

                                    // Exposure Roll-up Line Items
                                    let reportCodeForExposureRollUpLineItems = "FEC0D928-9E3D-4FE5-804C-0ECEEF9D8E35";
                                    let exposureRollUpParams = AggregateExposureOverTimeReportGenerator.copyExposureRollUpLineItemsParametersFromCoreExposureReportParameters(parameters, dayId);
                                    let exposureRollUpPersistedSettings: any = {};
                                    if (exposure.tagSet && exposure.tagSet.id > 0) {
                                        // The grouping name for the tag set in exposure roll-up line items is tagSet<TagSetId>.
                                        exposureRollUpPersistedSettings.ExposureTable = {
                                            "groupBy": [{ "id": "all" }, { "id": "tagSet" + exposure.tagSet.id }]
                                        };
                                    }

                                    let exposureRollUpUrl = Solovis.Reports.ReportLinker.getReportLink({
                                        reportCode: reportCodeForExposureRollUpLineItems,
                                        parameters: exposureRollUpParams,
                                        persistedSettings: exposureRollUpPersistedSettings,
                                        autoRun: true
                                    });
                                    let exposureRollUpLabel = "Exposure Roll-up Line Items"
                                    if (dayId) {
                                        exposureRollUpLabel += " - " + InvData.DayId.format(dayId);
                                    }

                                    // Aggregate Exposure Over Time Chart
                                    let reportCodeForAggregateExposureOverTimeChart = "A698B934-ABD2-4162-A9CF-6BD27E1C8C22";
                                    let aggregateExposureOverTimeChartParams = AggregateExposureOverTimeReportGenerator.copyCoreExposureParametersFromCoreExposureReportParameters(parameters);

                                    let aggregateExposureOverTimeChartUrl = Solovis.Reports.ReportLinker.getReportLink({
                                        reportCode: reportCodeForAggregateExposureOverTimeChart,
                                        parameters: aggregateExposureOverTimeChartParams,
                                        autoRun: true
                                    });
                                    let aggregateExposureOverTimeChartLabel = "Aggregate Exposure Over Time Chart"                                    

                                    let links = [];

                                    links.push({
                                        label: exposureRollUpLabel,
                                        href: exposureRollUpUrl
                                    });

                                    links.push({
                                        label: aggregateExposureOverTimeChartLabel,
                                        href: aggregateExposureOverTimeChartUrl
                                    });

                                    return links;
                                },

                                aggregateRow: {
                                    display: "inline",
                                    groupHeaderColspan: 1
                                },

                                rowData: "dataSets.exposure.lineItems",

                                modelEnvironment: { path: "exposure.modelEnv" }
                            },

                            dataSources: [
                                { name: "exposure", ref: { elementName: "Root", dataSourceName: "exposure" } }
                            ]
                        }
                    ],

                    dataSources: [
                        dataSourceForExposure
                    ]
                }
            };

            return report;
        };


        public static copyCoreExposureParametersFromCoreExposureReportParameters(parameters) {
            let params: any = {};

            params.assetList = parameters.assetList;
            params.assetSelectionSet = parameters.assetSelectionSet;

            params.asOfDayId = parameters.asOfDayId;
            params.periodLength = parameters.periodLength;
            params.periodsBack = parameters.periodsBack;

            params.profile = parameters.profile;
            params.tagSet = parameters.tagSet;

            params.exposureType = parameters.exposureType;

            params.targetCurrency = parameters.targetCurrency;

            params.sourceData = parameters.sourceData;

            return params;
        }

        public static copyExposureRollUpLineItemsParametersFromCoreExposureReportParameters(parameters, dayId) {
            let params: any = {};

            params.assetList = parameters.assetList;
            params.assetSelectionSet = parameters.assetSelectionSet;

            // Note: Different parameter name.
            params.asOfDate = dayId ? dayId : parameters.asOfDayId;

            params.profile = parameters.profile;
            params.tagSet = parameters.tagSet;

            params.targetCurrency = parameters.targetCurrency;

            params.useBookedValues = parameters.sourceData ? params.sourceData.useBookedValues : false;
            params.knowledgeDateTimestamp = parameters.sourceData ? params.sourceData.knowledgeDateTimestamp : null;

            return params;
        }
    }

}